export function checkboxCellRenderer(isChecked: boolean): HTMLElement {
    const result = document.createElement('i');
    const style = isChecked ? 'fa-check-square' : 'fa-square';
    result.className = `far ${style}`;
    return result;
}